import React from 'react'
import { inject, observer } from 'mobx-react'
import config from '../../utils/config'

const Logo = ({ translationStore }) => {
  let logo = "/icons/logo-easyplus.png"

  return (
    <a href='/' className='no-underline'>
      <img className='logo' src={logo} alt="Logo" />
    </a>
  )
}

export default inject('translationStore')(observer(Logo))



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js